export default __webpack_public_path__ + "static/media/screen_telegram_3.311f0f60.png";